import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import useApiCaller from 'hooks/apiCaller';
import { toast } from 'react-toastify';
import ShippingDialog from './components/ShippingDialog';

/**
 * Popup-only route opened straight from the winner-notification email
 * (/dyk-winner-shipping?dykWinner=<id>&year=<y>&month=<m>). It loads that one
 * winner, shows the Prize Shipping Details dialog on a plain backdrop, and sends
 * the user to the home page once they save or close.
 */
const WinnerShipping = () => {
  const apiCaller = useApiCaller();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const winnerId = params.get('dykWinner');
  const year = Number(params.get('year'));
  const month = Number(params.get('month'));

  const [winner, setWinner] = useState(null);
  const [loading, setLoading] = useState(true);

  const goHome = () => navigate('/', { replace: true });

  useEffect(() => {
    if (!winnerId || !year || !month) {
      toast.error('Invalid shipping link');
      goHome();
      return;
    }
    apiCaller
      .post('/super-user/dyk/winners/list', { year, month })
      .then((res) => {
        const w = (res.data?.data?.winners || []).find((x) => String(x._id) === String(winnerId));
        if (w) {
          setWinner(w);
        } else {
          toast.error('Winner not found');
          goHome();
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || 'Failed to load winner');
        goHome();
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {loading ? (
        <CircularProgress />
      ) : (
        <ShippingDialog
          open={!!winner}
          onClose={goHome}
          apiCaller={apiCaller}
          winner={winner}
          onSaved={goHome}
        />
      )}
    </Box>
  );
};

export default WinnerShipping;
